import { render, staticRenderFns } from "./ServiceUploadTechnical.vue?vue&type=template&id=6284e4fa&"
import script from "./ServiceUploadTechnical.vue?vue&type=script&lang=js&"
export * from "./ServiceUploadTechnical.vue?vue&type=script&lang=js&"
import style0 from "./ServiceUploadTechnical.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports